import { observer } from 'mobx-react';
import React from 'react';
import { ChatListStore } from 'eTip--common';

import { WriteMessage, MessageList, ChatComponent } from 'desktop--design-library';
import { Instance } from 'mobx-state-tree';

export interface IChatContainerProps {
    chatStore: Instance<typeof ChatListStore>;
    subscribeMessagesAgain: () => void;
}

export const ChatContainer = observer((props: IChatContainerProps) => {

    return (
        props.chatStore.canShowChat ? /* to react on change from SignalR */
            <ChatComponent
                state={props.chatStore.state}
                writeMessageNode={
                    <WriteMessage
                        isSending={props.chatStore.isSending}
                        writtenMessage={props.chatStore.writtenMessage}
                        hasPersonNickname={props.chatStore.hasPersonNickname}
                        isPrivate={props.chatStore.isPrivate}
                        errorMessage={props.chatStore.errorMessage}
                        isUserLogged={props.chatStore.personId > 0}
                        isBlockedPrivateMessage={props.chatStore.isBlockedPrivateMessage}
                        blockAllSendingInfoIsLoading={props.chatStore.blockAllSendingInfoIsLoading}
                        isResponseToAnotherMessage={!!props.chatStore.writingResponseOf}
                        writingResponseOf={props.chatStore.writingResponseOf}
                        addEmoticon={(symbol: string) => { props.chatStore.addEmoticon(symbol) }}
                        setWrittenMessage={(value: string) => { props.chatStore.setWrittenMessage(value); }}
                        sendMessage={() => { props.chatStore.sendMessageAsync(); }}
                        toggleBlockAllPrivate={() => { props.chatStore.toggleBlockAllPrivateAsync(); }}
                        togglePrivate={() => { props.chatStore.togglePrivate(); }}
                        clearAnswerFor={props.chatStore.clearReplayTarget}
                    />
                }
                messageListNode={
                    <MessageList
                        messages={props.chatStore.messages}
                        personId={props.chatStore.personId}
                        hasNickname={props.chatStore.hasPersonNickname}
                        isBlockChangeSendingMap={props.chatStore.isBlockChangeSendingMap}
                        setReplyTarget={(id: string, senderId: number, nickname: string) => { props.chatStore.setReplyTarget(id, senderId, nickname); }}
                        toggleBlockedPerson={(messageId: string, senderId: number) => { props.chatStore.toggleBlockedPersonAsync(messageId, senderId); }}
                    />
                }

                errorMessage={props.chatStore.errorMessage}

                subscribeMessagesAgain={() => { props.subscribeMessagesAgain() }}
            />
            :
            <></>);
});